export default __webpack_public_path__ + "static/media/share.3d54bf06.svg";